import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["template", "button"]

  declare readonly templateTarget: HTMLTemplateElement
  declare readonly buttonTarget: HTMLButtonElement

  add(): void {
    this.buttonTarget.before(this.templateTarget.content.cloneNode(true))
  }

  remove(event: Event): void {
    (event.currentTarget as HTMLElement).closest("[data-repeatable-input-entry]")?.remove()
  }
}
